import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import styles from './CardDetails.module.scss';
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { VscDebugDisconnect } from "react-icons/vsc";
import { convertDateToString, formatNumberWithComma } from "../../../components/functions/utilities";
import { MdOutlineEdit as EditIcon } from "react-icons/md";
import { IpNames, LoadingProgressType, PnlCategoryNames, PnlFsMetricNames, PnlFsNames, ProductFetchingProgress, TypeOfFinanceOption, formActionTypes } from "../../../interfaces/interfaces";
import CategoryForm from "../CategoryForm/CategoryForm";
import { useSearchParams } from "react-router-dom";
import { RiMore2Fill as MoreOptionsIcon } from "react-icons/ri";
import { ControlledMenu, MenuDivider, MenuItem, useClick } from "@szhsin/react-menu";
import { CustomMenu } from "../../ReportDetails/Components/Cards/CardMenu";
import { HiOutlineAdjustments as ManageAccountIcon } from 'react-icons/hi'
import ManageAccounts from "../ManageAccounts/ManageAccounts";
import { useAppSelector } from "../../../redux/reduxHooks";
import CircularLoader from "../../../components/common/CircularLoader/CircularLoader";
import LoanForm from "../LoanForm/LoanForm";
import { RestS } from "../../../rest/rest-service";
import { RiErrorWarningFill as ErrorIcon } from 'react-icons/ri';

type Props = {
  fsMetricItem: any;
  sectionData: { [key: string]: any };
  ipConfigs: { [key: string]: any };
  category: string;
  isManageAccount: boolean;
  financeStatmentOptions: any;
  connectionToggle: () => void,
  monthLabels: string[];
  metricOptions: {
    id: number;
    label: string;
    type: TypeOfFinanceOption,
    value: string;
  }[],
  refreshTabs: () => void;
  currentCardKey: string;
  expiredAccountsConfig: { [x: string]: any },
  productFetchingStatus: { status: ProductFetchingProgress, isProductUpdate: boolean },
  amzAdsData: any[],
  fetchingIpStatus: string[];
  isOutstanding?: boolean;
}



const CardDetails = forwardRef(({ fsMetricItem, ipConfigs, sectionData, category, isManageAccount, financeStatmentOptions, connectionToggle, monthLabels, metricOptions, refreshTabs, currentCardKey, expiredAccountsConfig, productFetchingStatus, amzAdsData, fetchingIpStatus, isOutstanding = false }: Props, ref: any) => {
  const cardRef = useRef(null);
  const [openForm, setOpenForm] = useState(false);
  const [actionType, setActionType] = useState<formActionTypes>(null);
  const [formCategoryName, setFormCategoryName] = useState(null);
  const [formCategoryId, setFormCategoryId] = useState(null);
  const [formMetricId, setFormMetricId] = useState(null);
  const [financeStatementId, setFinanceStatementId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openManageAccPopup, setOpenManageAccPopup] = useState(false);

  const moreOptionsRef = useRef(null);
  const [isMoreOptionOpen, setMoreOptionsOpen] = useState(false);
  const anchorProps = useClick(isMoreOptionOpen, setMoreOptionsOpen);
  const [openLoanForm, setOpenLoanForm] = useState(false);
  const [availableDataError, setAvailableDataError] = useState(null);

  const scrollToElement = (element) => {
    const container = ref?.current;
    console.log('container Ref', container)
    if (element && container) {

      const elementRect = element.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      console.log('elementRect', elementRect, containerRect)
      container.scrollBy({ top: elementRect.top - containerRect.top, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (fsMetricItem && fsMetricItem?.feMetricName == PnlFsMetricNames.amazonAds) {
      // availableMonthsData.length > 0 && availableMonthsData.length <= 3 ? `Data only available for ${availableMonthsData.length} months` : null
      if (amzAdsData.length > 0 && amzAdsData.length <= 3) {
        setAvailableDataError(`Data only available for ${amzAdsData.length} months`)
      } else {
        setAvailableDataError(null);
      }
    }
  }, [amzAdsData])


  useEffect(() => {
    const currentHash = window.location.hash;
    const section = searchParams.get('section');
    const card = searchParams.get('card');


    if (card) {

      const cardKey = `${section}-${card}`;


      // Construct the card key based on sectionName and cardName
      if (currentCardKey == cardKey) {
        console.log('cardKey', cardKey, currentCardKey, cardRef)
        // cardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          scrollToElement(cardRef.current);
        }, 100);
        searchParams.delete('section');
        searchParams.delete('card');
        setSearchParams(searchParams);
      }
    }
  }, [cardRef]);


  const { dfProgress, loadingType, extraConfig } = useAppSelector(state => state.dataFetchingProgress);
  const { missingCostItems } = useAppSelector(state => state.financeStatement);

  useEffect(() => {
    if (dfProgress) {
      refreshTabs();
    }
  }, [])

  const isMetricLoading = useMemo(() => {
    // console.log('extraConfig', extraConfig, fsMetricItem)
    if (dfProgress && (loadingType == LoadingProgressType.deleteDataFs || loadingType == LoadingProgressType.deleteDataInsight) && extraConfig?.fsMetricId === fsMetricItem?.fsmId) {
      return true;
    } else {
      return false;
    }
  }, [dfProgress, loadingType, extraConfig]);



  const cardConfig = useMemo(() => {
    // console.log('expiredAccountsConfig', expiredAccountsConfig)
    const isDataSourcePresent = fsMetricItem?.fsmDataSource && fsMetricItem?.fsmDataSource.length;
    const ipLogo = isDataSourcePresent && ipConfigs[fsMetricItem?.fsmDataSource[0]] ? ipConfigs[fsMetricItem?.fsmDataSource[0]]['logo'] : null;
    const connectionStatus = isDataSourcePresent && ipConfigs[fsMetricItem?.fsmDataSource[0]] ? ipConfigs[fsMetricItem?.fsmDataSource[0]]['connectionStatus'] : false;
    const expiredAccountsCount = isDataSourcePresent && expiredAccountsConfig[fsMetricItem?.fsmDataSource[0]] != undefined ? expiredAccountsConfig[fsMetricItem?.fsmDataSource[0]] : 0;
    const dataSource = isDataSourcePresent ? fsMetricItem?.fsmDataSource[0] : null;
    let fetchingData = isDataSourcePresent && dataSource == IpNames.shopify && productFetchingStatus.status == ProductFetchingProgress.inProgress && !productFetchingStatus?.isProductUpdate ? true : false;
    if (fetchingIpStatus) {
      // console.log('fetchingIpStatus', fetchingIpStatus)
      const ipStatusSet = new Set([...fetchingIpStatus]);
      if (ipStatusSet.has(dataSource)) {
        fetchingData = true;
      }
    }
    // console.log('connection status', fsMetricItem, connectionStatus)
    return { isDataSourcePresent, ipLogo, connectionStatus, expiredAccountsCount, dataSource, fetchingData }
  }, [fsMetricItem, expiredAccountsConfig, productFetchingStatus, fetchingIpStatus]);


  const { isDataSourcePresent, ipLogo, connectionStatus, expiredAccountsCount, dataSource } = cardConfig;

  const closeForm = (fetchTabs = false) => {
    if (formCategoryName == PnlFsNames.loanServicing) {
      setOpenLoanForm(false);
    } else {
      setOpenForm(false);
    }
    setOpenForm(false);
    setActionType(null);
    setFormMetricId(null);
    setFormCategoryName(null);
    setFinanceStatementId(null);
    if (fetchTabs) {
      refreshTabs();
    }
  }

  const closeManageAccPopup = () => {
    setOpenManageAccPopup(false);
  }

  const alterFeCategoryTitle = [PnlCategoryNames.shippingCost, PnlCategoryNames.shippingCost, PnlCategoryNames.platformCommision, PnlCategoryNames.taxes, PnlCategoryNames.packagingCost] as string[];

  const formHeaderTitle = useMemo(() => {
    // console.log('fsMetricsItem', fsMetricItem)
    if (fsMetricItem && alterFeCategoryTitle.includes(category) && fsMetricItem?.fsmDataSource.length) {
      let title = `${category} for ${fsMetricItem?.feMetricName}`;
      return {
        editTitle: title,
        addTitle: title,
      }
    } else {
      return {
        editTitle: `Update ${fsMetricItem?.feMetricName.length > 50 ? fsMetricItem?.feMetricName.substring(0, 50) + '...' : fsMetricItem?.feMetricName}`,
        addTitle: `Add ${category}`
      }
    }
  }, [fsMetricItem]);

  return (
    <>
      <div ref={cardRef} key={fsMetricItem?.fsmId} className={styles.card}>
        <div className={styles.cardLeftContainer}>
          {isDataSourcePresent && ipLogo ?
            <div className={styles.ipLogo}>
              <img src={ipLogo} />
            </div> : null
          }
          <div className={styles.cardTitleRootContainer}>
            <div className={styles.cardTitleContainer}>

              <div className={styles.cardTitle}>
                <div className={styles.cardTitle}>
                  {fsMetricItem?.feMetricName}
                </div>


              </div>
              {isDataSourcePresent ? <div className={`${styles.statusContainer} ${connectionStatus ? styles.active : styles.inactive}`}>

              </div> : null}
            </div>
            {availableDataError ? <div className={styles.dataAvailableContainer}>
              {availableDataError}
            </div> : null}
            {(isOutstanding && category == PnlFsNames.loanServicing) || missingCostItems?.items[fsMetricItem?.feMetricName] ? <div className={styles.outStandingErrorContainer}>
              <div className={styles.iconContainer}>
                <ErrorIcon />
              </div>
              <div className={styles.errorText}>
                {
                  isOutstanding && category == PnlFsNames.loanServicing ?
                    'Outstanding loan amount is missing' :
                    `Not updated for ${convertDateToString(missingCostItems?.lastMonth, true)}`
                }
              </div>
            </div> : null}

          </div>


        </div>
        <div className={styles.cardRightContainer}>
          <>
            {isDataSourcePresent && !connectionStatus && expiredAccountsCount == 0 ?
              <MeritoButton icon={<VscDebugDisconnect />} btnText="Connect" type="primary-1" onClick={() => connectionToggle()} /> : <>
                {isMetricLoading || cardConfig?.fetchingData ? <div>
                  <CircularLoader />
                </div> : fsMetricItem?.totalCost != null ? <div className={styles.value}>
                  {`${fsMetricItem?.unit ? fsMetricItem?.unit : '₹'}${formatNumberWithComma(fsMetricItem?.totalCost)}`}
                </div> : <div className={styles.value}>
                  {`-`}
                </div>}

                {fsMetricItem?.isEditable && !(isMetricLoading || cardConfig?.fetchingData) ? <button className={styles.iconBtn} onClick={() => {
                  setFinanceStatementId(fsMetricItem.fsId);
                  setFormMetricId(fsMetricItem.fsmId);
                  setFormCategoryId(sectionData.categoryId)
                  setFormCategoryName(category);
                  setActionType(formActionTypes.edit);
                  if (category == PnlFsNames.loanServicing) {
                    setOpenLoanForm(true)
                  } else {
                    setOpenForm(true);
                  }

                }}>

                  <EditIcon />
                </button> : null}
              </>}

            {isManageAccount && (expiredAccountsCount || connectionStatus) ?
              <button ref={moreOptionsRef} {...anchorProps} className={styles.iconBtn}>
                <MoreOptionsIcon />
              </button>
              : null}

            <CustomMenu
              menuStyle={{ marginTop: "0.5rem" }}
              align="end" maxWidth={"13.12rem"} minWidth={"13.12rem"} state={isMoreOptionOpen ? 'open' : 'closed'} anchorRef={moreOptionsRef} onClose={() => setMoreOptionsOpen(false)}>
              <div>
                <>
                  {!connectionStatus && expiredAccountsCount != 0 && <MenuItem onClick={({ syntheticEvent, stopPropagation }) => {
                    syntheticEvent.stopPropagation();
                    stopPropagation = true;
                    connectionToggle();
                  }}>
                    <div className={styles.menuInnerContainer}>
                      <div className={styles.menuItemIcon}>
                        <VscDebugDisconnect />
                      </div>
                      <div className={styles.menuItemText}>
                        Connect Account
                      </div>
                    </div>
                  </MenuItem>}
                  {!connectionStatus && expiredAccountsCount != 0 ? <MenuDivider /> : null}

                  <MenuItem onClick={({ syntheticEvent, stopPropagation }) => {
                    syntheticEvent.stopPropagation();
                    stopPropagation = true;
                    setOpenManageAccPopup(true)
                  }}>
                    <div className={styles.menuInnerContainer}>
                      <div className={styles.menuItemIcon}>
                        <ManageAccountIcon />
                      </div>
                      <div className={styles.menuItemText}>
                        Manage Ad Accounts
                      </div>
                    </div>
                  </MenuItem>
                </>
              </div>
            </CustomMenu>
          </>



        </div>
      </div >

      {openForm ? <CategoryForm formHeaderTitle={formHeaderTitle} financeStatmentId={financeStatementId} financeStatementOptions={financeStatmentOptions} ipConfigs={ipConfigs} categoryId={formCategoryId} formMetricId={formMetricId} monthLabels={monthLabels} metricOptions={metricOptions} isOpen={openForm} setOpen={setOpenForm} closeForm={closeForm} actionType={actionType} categoryName={formCategoryName} /> : null}
      {openLoanForm ? <LoanForm formHeaderTitle={formHeaderTitle} isOpen={openLoanForm} setOpen={setOpenLoanForm} closeForm={closeForm} actionType={actionType} categoryId={formCategoryId} categoryName={formCategoryName} monthLabels={monthLabels} formMetricId={formMetricId} ipConfigs={ipConfigs} /> : null}


      {openManageAccPopup ?
        <ManageAccounts
          fsMetricId={fsMetricItem?.fsmId}
          isOpen={openManageAccPopup}
          setOpen={setOpenManageAccPopup}
          closePopup={closeManageAccPopup}
          ipName={dataSource}
          ipLogo={ipLogo}
        />
        : null}
    </>
  );
});

export default CardDetails;
